import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const RESERVE_SCROLL_BAR_GAP = 'reserveScrollBarGap';
const options = {
  reserveScrollBarGap: true,
};

// 追踪鎖定狀態的計數
let scrollLockCount = 0;

const BodyScrollLock = {
  inserted(el, binding) {
    if (binding.value) {
      scrollLockCount += 1;
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      || (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);
      // 新版 ipad 不會有 iPad 字樣

      if (isIOS) {
        document.body.style.overflow = 'hidden';
      } else {
        disableBodyScroll(el, options);
      }
    }
  },
  componentUpdated(el, binding) {
    if (binding.oldValue !== binding.value) {
      if (binding.value) {
        scrollLockCount += 1;
        if (binding.arg === RESERVE_SCROLL_BAR_GAP) {
          disableBodyScroll(el, options);
        } else {
          disableBodyScroll(el);
        }
      } else {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (scrollLockCount === 0) {
          document.body.style.overflow = '';
          enableBodyScroll(el);
          clearAllBodyScrollLocks();
        }
      }
    }
  },
  unbind(el) {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      // 確保在組件完全銷毀後解除鎖定
      setTimeout(() => {
        if (scrollLockCount === 0) {
          document.body.style.overflow = '';
          enableBodyScroll(el);
          clearAllBodyScrollLocks();
        }
      }, 0);
    }
  },
};

export default BodyScrollLock;
